let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '厂商标识',
        props: 'manufactorId',
        minWidth: 200,
    },
    {
        label: '充电桩型号名称',
        props: 'pileTypeName',
        minWidth: 180,
    },
    {
        label: '充电桩编号',
        props: 'pileNo',
        minWidth: 200,
       
    },
    {
        label: '所属用户',
        props: 'custPhone',
        minWidth: 200,
        
    },
    {
        label: '是否有蓝牙',
        props: 'isBluetooth',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.isBluetooth == 'Y') {
                return "是";
            }
            else if (row.isBluetooth == 'N') {
                return '否'
            }else{
                return ''
            }
        }
    },
    {
        label: '当前版本号',
        props: 'currentVersionNo',
        minWidth: 200,
    },
    {
        label: '最新版本号',
        props: 'versionId',
        minWidth: 200,
    },
    {
        label: '新版本下发时间',
        props: 'checkedTime',
        minWidth: 200,
    },
    {
        label: '版本描述',
        props: 'versionDesc',
        minWidth: 100,
    },
    {
        label: '版本下载路径',
        props: 'versionDownloadPath',
        minWidth: 200,
    },

    {
        label: '升级方式',
        props: 'upgradeMethod',
        minWidth: 200,
    },
    {
        label: '升级状态',
        props: 'upgradeStatus',
        minWidth: 200,
    },
    {
        label: '升级开始时间',
        props: 'upgradeStartTime',
        minWidth: 200,
    },
    {
        label: '升级结束时间',
        props: 'upgradeEndTime',
        minWidth: 200,
    },
    {
        label: '升级失败原因',
        props: 'upgradeFailReason',
        minWidth: 200,
    },
];

//充电记录列表项
pageConfig.chargeRecordColumns = [
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 200,
    },
    {
        label: '充电桩编号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 180,
        tooltip:true,
    },
    {
        label: '账号类型',
        props: 'custTypeName',
        minWidth: 180,
        tooltip:true,
    },
    {
        label: '开始时间',
        props: 'beginTime',
        minWidth: 320,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 200,
    },
    {
        label: '充电时长（分）',
        props: 'chargeMin',
        minWidth: 200,
    },
    {
        label: '订单属性',
        props: 'orderPropertyName',
        minWidth: 120,
    },
    {
        label: '充电电量（kW·h）',
        props: 'chargeVal',
        minWidth: 200,
    },
];

//抢修列表项
pageConfig.repairColumns = [
    {
        label: '充电桩编号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '维修工单',
        props: 'repairNo',
        minWidth: 200,
    },
    {
        label: '所属站点',
        props: 'stationName',
        minWidth: 320,
    },
    {
        label: '维修状态',
        props: 'repairStatus',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.repairStatus == '01') {
                return "未维修";
            }
            else {
                return '已维修'
            }
        }
    },
    {
        label: '维修结果',
        props: 'repairResult',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.repairResult == '01') {
                return "未修复";
            }
            else {
                return '已修复'
            }
        }
    },
    {
        label: '申请日期',
        props: 'applyTime',
        minWidth: 200,
    },
    {
        label: '维修天数',
        props: 'repairDateNum',
        minWidth: 200,
    },
    {
        label: '申请原因',
        props: 'applyReason',
        minWidth: 120,
    },
    {
        label: '维修回执',
        props: 'corpReturn',
        minWidth: 200,
    },
    {
        label: '维修人',
        props: 'repairPerson',
        minWidth: 180,
    },
];

//故障记录列表项
pageConfig.faultRecordColumns = [
    {
        label: '充电桩编码',
        props: '',
        minWidth: 200,
    },
    {
        label: '故障时间',
        props: '',
        minWidth: 180,
        tooltip:true,
    },
    {
        label: '故障描述',
        props: '',
        minWidth: 320,
    },
    {
        label: '故障备注',
        props: '',
        minWidth: 200,
    },
];

// 关联账号详情列表
pageConfig.relationColumns = [
    {
        label: '充电桩编码',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '关联账号类型',
        props: 'custTypeName',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '关联时间',
        props: 'lastModifiedWhen',
        minWidth: 320,
    },
]

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '设备升级'
    },
    {
        type: 'title',
        name: '升级管理'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.UpgradeManagement = 'UpgradeManagement';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '设备升级',
    },
    {
        type: 'router',
        name: '升级管理',
        router: 'UpgradeManagement'
    },
    {
        type: 'title',
        name: '升级记录'
    }
];

// 关联账号 详情面包屑
pageConfig.relationBreadCrunm = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '关联账号详情'
    }
]

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
